import { render, staticRenderFns } from "./GreenBanner.vue?vue&type=template&id=177492e8&scoped=true&"
import script from "./GreenBanner.vue?vue&type=script&lang=js&"
export * from "./GreenBanner.vue?vue&type=script&lang=js&"
import style0 from "./GreenBanner.vue?vue&type=style&index=0&id=177492e8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "177492e8",
  null
  
)

export default component.exports